// src/validations/updateProfileSchema.ts

import * as Yup from 'yup';

export const updateProfileSchema = Yup.object({
  name: Yup.string()
    .required('Name is required'),

  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),

  phone: Yup.string()
    .matches(/^[0-9]+$/, 'Phone number must be a digit')
    .min(10, 'Phone number must be at least 10 digits')
    .max(15, 'Phone number is too long')
    .optional(),

  address: Yup.string()
    .optional(),

  education: Yup.object().shape({
    bachelor: Yup.object().shape({
      collegeName: Yup.string().optional(),
      degree: Yup.string().optional(),
      graduationYear: Yup.number()
        .min(1900, 'Year must be after 1900')
        .max(new Date().getFullYear() + 1, 'Year must be valid')
        .optional(),
    }).optional(),

    master: Yup.object().shape({
      collegeName: Yup.string().optional(),
      degree: Yup.string().optional(),
      graduationYear: Yup.number()
        .min(1900, 'Year must be after 1900')
        .max(new Date().getFullYear() + 1, 'Year must be valid')
        .optional(),
    }).optional(),
  }).optional(),
});
